export default __webpack_public_path__ + "static/media/image07.8a243d7e.jpg";